<template>
  <social-sharing :networks="overriddenNetworks" :url="'https://portal.sportecos.com' + this.$route.fullPath"
    :title="drillName" :description="drillName" :quote="drillDesc" :hashtags="this.sportType + ',' + this.tags"
    :media="this.videoUrl" twitter-user="SportEcoSys" inline-template>
    <div class="social-sharing-wrapper">
      <network network="email">
        <v-icon size="18">
          fa-globe
        </v-icon>
      </network>
      <!-- <network network="custom">
          <v-icon size="24px">fas fa-link</v-icon>
      </network>       -->
      <network network="facebook">
        <v-icon size="18">fab fa-facebook</v-icon>
      </network>
      <!-- <network network="instagram">
        <i class="fa fa-instagram"></i> 
      </network> -->
      <!-- <network network="line">
        <v-icon>fab fa-line</v-icon>
      </network> -->
      <network network="linkedin">
        <v-icon size="18">fab fa-linkedin</v-icon>
      </network>
      <network network="odnoklassniki">
        <v-icon size="18">fab fa-odnoklassniki</v-icon>
      </network>
      <network network="telegram">
        <v-icon size="18">fab fa-telegram</v-icon>
      </network>
      <network network="twitter">
        <v-icon size="18">fab fa-twitter</v-icon>
      </network>
      <network network="whatsapp">
        <v-icon size="18">fab fa-whatsapp</v-icon>
      </network>
      <!-- <network network="pinterest">
        <v-icon>fab fa-pinterest</v-icon>
      </network>
      <network network="reddit">
        <v-icon>fab fa-reddit</v-icon>
      </network>
      <network network="skype">
        <v-icon>fab fa-skype</v-icon> 
      </network> -->
      <!--network network="sms">
        <v-icon>far fa-comment-dots</v-icon> SMS
      </network-->
      <!-- <network network="vk">
        <v-icon>fab fa-vk</v-icon> 
      </network>
      <network network="weibo">
        <v-icon>fab fa-weibo</v-icon> 
      </network>  -->
    </div>
  </social-sharing>
</template>

<script>
export default {
  props: [
    "drillName",
    "drillDesc",
    "tags",
    "videoUrl",
    "sportType",
    "imageUrl"
  ],
  data() {
    return {
      overriddenNetworks: {
        custom: {
          sharer: "https://mycustomdomain.com",
          type: "popup"
        }
      }
    };
  },
  mounted() { }
};
</script>
<style lang="scss">
.social-sharing-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;

  span {
    width: calc(100% / 7);
    text-align: center;
    padding: 12px;
    cursor: pointer;
    transition: ease-in 0.3s;

    i {
      padding: 7px 7px;
      border: 1px solid white;
      border-radius: 50%;
    }
  }

  span:hover {
    background-color: white;

    i {
      color: #0277bd;
      border: 1px solid #0277bd;
    }
  }
}
</style>
